// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qf-0";